import { connect } from 'react-redux';
import DateRangeFilter from '../components/DateRangeFilter/DateRangeFilter';
import * as actions from '../actions/dateRangeFilterActionCreators';

const mapStateToProps = state => ({ dateRangeFilter: state.dateRangeFilter });

export default connect(mapStateToProps, actions)(DateRangeFilter);
